






import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { DialogService } from '@/shared/dialog/dialog-service'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import AddOrganisationDialog from '@/business/administration/components/add-organisation-dialog.vue'
import { AdministrationModule } from '@/business/administration/store/administration-module'
import { imageUrl } from '@/shared/utils/images'

@Component({
  components: {
    AddOrganisationDialog,
  },
})
export default class HomeOrganisations extends Vue {
  public organisations: OrganisationLite[] = []

  private dialogService = Injector.get(DialogService)
  private adminModule = Injector.get(AdministrationModule)

  public mounted() {
    this.$watch(
      () => this.adminModule.data.offers,
      value => {
        this.organisations = value.map(organisation => this.mapEntry(organisation))
      }
    )
  }

  public addOrganisation(organisation: OrganisationLite) {
    this.organisations.push(this.mapEntry(organisation))
  }

  public openAddOrganisationDialog() {
    this.dialogService.open(AddOrganisationDialog.dialogName)
  }

  private mapEntry(entry: OrganisationLite): OrganisationLite {
    return {
      ...entry,
      description: entry.description || '',
      image: imageUrl(entry.image, 350),
    }
  }
}
